export const getStringLength = ({
  str,
  fontFamily,
  fontSize,
  fontWeight,
}: {
  str: string;
  fontSize: number;
  fontFamily?: string;
  fontWeight: number;
}) => {
  const canvas = globalThis?.document?.createElement?.('canvas');
  const context = canvas?.getContext?.('2d');

  if (!context) {
    return 0;
  }

  context.font = `${fontWeight} ${fontSize}px ${fontFamily || 'sans-serif'}`;

  const metrics = context.measureText(str);

  return metrics.width;
};
